import { config } from '@config/config';
import { pipe } from 'rxjs';
import { map } from 'rxjs/operators';
import { UrlUtils } from '@app/utils/url.utils';
var Page = /** @class */ (function () {
    function Page(page, pageSize, sortField, sortDirection, upper, lower) {
        this._page = Math.floor(page) || 1;
        this._pageSize = Math.floor(pageSize) || 20;
        this._sortField = sortField || 'id';
        this._sortDirection = sortDirection || 'DESC';
        this._upper = upper;
        this._lower = lower;
        this.validate();
    }
    Page.fromUrl = function (url) {
        var params = UrlUtils.getUrlParams(url);
        var page = new Page();
        if (params.limit && params.offset) {
            page._page = Math.floor(Number(params.offset) / Number(params.limit)) + 1;
            page._pageSize = Math.floor(Number(params.limit));
        }
        page._sortField = params.sortField || 'id';
        page._sortDirection = (params.sortDirection || 'DESC');
        return page;
    };
    Page.sort = function (sortField, sortDirection) {
        return pipe(map(function (models) {
            return models.sort(function (a, b) {
                if (sortDirection === 'ASC') {
                    return a[sortField] < b[sortField] ? -1 : 1;
                }
                else {
                    return a[sortField] > b[sortField] ? -1 : 1;
                }
            });
        }));
    };
    Page.deserialize = function (input) {
        var params = input.split('|');
        var page = new Page(Number(params[0]), Number(params[1]), params[2], params[3]);
        page.setBounds(params[4], params[5]);
        page._cursor = params[6];
        return page;
    };
    Page.prototype.serialize = function () {
        var arr = [
            this._page,
            this._pageSize,
            this._sortField,
            this._sortDirection,
            this._upper,
            this._lower,
            this._cursor,
        ];
        return arr.join('|');
    };
    Object.defineProperty(Page.prototype, "page", {
        get: function () {
            return this._page;
        },
        set: function (p) {
            this._page = Math.floor(p) || 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Page.prototype, "pageSize", {
        get: function () {
            return this._pageSize;
        },
        set: function (s) {
            this._pageSize = Math.floor(s) || 20;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Page.prototype, "sortField", {
        get: function () {
            return this._sortField;
        },
        set: function (f) {
            this._sortField = f;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Page.prototype, "sortDirection", {
        get: function () {
            return this._sortDirection;
        },
        set: function (d) {
            this._sortDirection = d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Page.prototype, "limit", {
        get: function () {
            return Math.floor(this._pageSize);
        },
        set: function (l) {
            this._pageSize = Math.floor(l);
            if (this._pageSize < 1) {
                this._pageSize = 1;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Page.prototype, "offset", {
        get: function () {
            if (this._pageSize === Infinity) {
                return 0;
            }
            return Math.floor((this._page - 1) * this._pageSize);
        },
        set: function (o) {
            if (this._pageSize !== Infinity) {
                this._page = Math.floor((Number(o) || 0) / this._pageSize) + 1;
            }
        },
        enumerable: true,
        configurable: true
    });
    Page.prototype.next = function () {
        this._page++;
    };
    Page.prototype.prev = function () {
        this._page--;
        if (this._page < 1) {
            this._page = 1;
        }
    };
    Page.prototype.setBounds = function (upper, lower) {
        this._upper = upper;
        this._lower = lower;
    };
    Object.defineProperty(Page.prototype, "cursor", {
        get: function () {
            return this._cursor;
        },
        set: function (c) {
            this._cursor = c;
        },
        enumerable: true,
        configurable: true
    });
    Page.prototype.sort = function () {
        var _this = this;
        return pipe(map(function (models) {
            return models.sort(function (a, b) {
                if (_this._sortDirection === 'ASC') {
                    if (a[_this._sortField] < b[_this._sortField]) {
                        return -1;
                    }
                    else if (a[_this._sortField] > b[_this._sortField]) {
                        return 1;
                    }
                    else {
                        return 0;
                    }
                }
                else {
                    if (a[_this._sortField] > b[_this._sortField]) {
                        return -1;
                    }
                    else if (a[_this._sortField] < b[_this._sortField]) {
                        return 1;
                    }
                    else {
                        return 0;
                    }
                }
            });
        }));
    };
    /**
     * Returns true if this page is equal to or contained within the
     * input Page, otherwise false
     * @param other The page to compare to
     */
    Page.prototype.compare = function (other) {
        if ((!this._upper && other._upper) ||
            (this._upper && !other._upper) ||
            (this._upper && other._upper && this._upper !== other._upper)) {
            return false;
        }
        if ((!this._lower && other._lower) ||
            (this._lower && !other._lower) ||
            (this._lower && other._lower && this._lower !== other._lower)) {
            return false;
        }
        var minItem = this.offset;
        var maxItem = this.offset + this.limit;
        var otherMinItem = other.offset;
        var otherMaxItem = other.offset + other.limit;
        return (minItem >= otherMinItem &&
            maxItem <= otherMaxItem &&
            this._sortField === other._sortField &&
            this._sortDirection === other._sortDirection);
    };
    Page.prototype.validate = function () {
        if (this._page < 1) {
            this._page = 1;
        }
        if (this._pageSize !== Infinity && this._pageSize > config.maxPageSize) {
            this._pageSize = config.maxPageSize;
        }
        if (this._pageSize === Infinity && this._page !== 1) {
            throw new Error('Page must be set to 1 if the page size is Infinity');
        }
    };
    return Page;
}());
export { Page };
